export enum Z_INDEX {
  under_everything = 900,
  under_dropdown = 990,
  sidebar = 980,
  dropdown = 1000,
  sticky = 1020,
  fixed = 1030,
  modalBackdrop = 1040,
  offcanvas = 1050,
  modal = 1060,
  popover = 1070,
  tooltip = 1080,
  modalOverTooltip = 1090,
  notification = 1100,
}
